import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { Applogo } from "../Routes/ImagePath";
export const useGeneratePdf = () => {
  const printRef = useRef(null);
  const [printing, setIsPrinting] = useState(false);
  const generatePdf = async (filename = "document") => {
    setIsPrinting(true);

    const element = printRef.current;
    if (!element) return;

    // Apply basic styles for printing
    // element.style.background = white;
    // element.style.color = black;
    // element.style.fontSize = "12px";

    await new Promise((resolve) => setTimeout(resolve, 300)); // wait for styles

    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");

    const imgProps = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    // Header Logo
    pdf.addImage(Applogo, "png", 90, 5, 15, 15);

    // Main content
    pdf.addImage(data, "PNG", 0, 20, pdfWidth, pdfHeight);

    // Footer
    const footerText = ` Issued using 'www.fintrack.expert`;
    const pageHeight = pdf.internal.pageSize.getHeight();
    const textWidth = pdf.getTextWidth(footerText);
    pdf.setFontSize(12);
    pdf.text(footerText, (pdfWidth - textWidth) / 2, pageHeight - 2);

    // Save file
    pdf.save(`${filename}.pdf`);
    setIsPrinting(false);
  };

  return { printRef, generatePdf, printing };
};
